import React, { useState } from 'react';
import styled from 'styled-components';
import GeneratedMessage from './GeneratedMessage';
import TextArea from './TextArea';

type GenerateFormProps = {
  generatedMessage?: string;
  onSubmit: (text: string) => void;
  onUpdate: (text: string) => void;
  loading: boolean;
};

const Container = styled.div``;

const Subtitle = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
`;

const TextBlock = styled.div`
  margin-bottom: 20px;
`;

const UpdateFormContainer = styled.div`
  margin-top: 20px;
`;

const GenerateForm = ({ generatedMessage, onSubmit, onUpdate, loading }: GenerateFormProps) => {
  const [showUpdateForm, setShowUpdateForm] = useState(false);

  const handleUpdate = (text: string): void => {
    onUpdate(text);
    setShowUpdateForm(false);
  };

  return (
    <Container>
      {generatedMessage || loading ? (
        <GeneratedMessage
          message={loading || !generatedMessage ? '' : generatedMessage}
          showUpdateForm={showUpdateForm}
          onUpdate={() => setShowUpdateForm(true)}
        />
      ) : (
        <div></div>
      )}

      {!generatedMessage && !loading ? (
        <>
          <Subtitle>Add additional context</Subtitle>
          <TextBlock>
            Add any additional context or information that you&apos;d like GPT to use when it
            generates a message to the customer. You can also provide instructions to GPT about how
            to write the message or what the message should say.
          </TextBlock>
          <TextArea onSubmit={onSubmit} update={false} />
        </>
      ) : (
        <div></div>
      )}

      {showUpdateForm ? (
        <UpdateFormContainer>
          <Subtitle>Add additional instructions</Subtitle>
          <TextBlock>Add instructions on how you&apos;d like to update the message.</TextBlock>
          <TextArea onSubmit={(text: string) => handleUpdate(text)} update={true} />
        </UpdateFormContainer>
      ) : (
        <div></div>
      )}
    </Container>
  );
};

export default GenerateForm;
